import { render, staticRenderFns } from "./MoleculeConfigChangeTrend.vue?vue&type=template&id=066af57a&scoped=true&"
import script from "./MoleculeConfigChangeTrend.vue?vue&type=script&lang=js&"
export * from "./MoleculeConfigChangeTrend.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeConfigChangeTrend.vue?vue&type=style&index=0&id=066af57a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066af57a",
  null
  
)

export default component.exports